import React from 'react';
import { useTranslation } from 'react-i18next';

const QuickStats: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section>
      <div className="container">
        <div className="section-title">
          <h2>{t('stats_heading')}</h2>
        </div>
        <div className="grid grid-3">
          <div className="card text-center" style={{minHeight: 'auto', padding: '1.2rem 1.5rem'}}>
            <div style={{fontSize: '2.5rem', color: 'var(--accent-maroon)', marginBottom: '0.5rem'}}>📦</div>
            <h3>{t('products_count')}</h3>
            <p>{t('products_count_desc')}</p>
            <p style={{fontSize: '0.85rem', color: 'var(--text-light)', marginTop: '0.5rem'}}>{t('products_count_extra')}</p>
          </div>
          <div className="card text-center" style={{minHeight: 'auto', padding: '1.2rem 1.5rem'}}>
            <div style={{fontSize: '2.5rem', color: 'var(--primary-dark)', marginBottom: '0.5rem'}}>😊</div>
            <h3>{t('customers_count')}</h3>
            <p>{t('customers_count_desc')}</p>
            <p style={{fontSize: '0.85rem', color: 'var(--text-light)', marginTop: '0.5rem'}}>{t('customers_count_extra')}</p>
          </div>
          <div className="card text-center" style={{minHeight: 'auto', padding: '1.2rem 1.5rem'}}>
            <div style={{fontSize: '2.5rem', color: 'var(--accent-maroon)', marginBottom: '0.5rem'}}>🎯</div>
            <h3>{t('satisfaction_text')}</h3>
            <p>{t('satisfaction_desc')}</p>
            <p style={{fontSize: '0.85rem', color: 'var(--text-light)', marginTop: '0.5rem'}}>{t('satisfaction_extra')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuickStats;